import type {FocusEvent} from 'react';

/**
 * For an `onBlur` handler: calls `close` when focus has moved to an element outside `container`.
 *
 * A blur with no `relatedTarget` is ignored: Safari blurs to nothing when a mouse click lands on a
 * button, which would close a menu before the click on its item arrives. Clicks outside are
 * `useOnClickOutside`'s job.
 */
export const closeOnFocusOut = (
  event: FocusEvent<HTMLElement>,
  container: HTMLElement | null,
  close: () => void
) => {
  if (event.relatedTarget && !container?.contains(event.relatedTarget as Node)) {
    close();
  }
};
